export default "__VITE_ASSET__DMQC6JtT__"